import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getPoliciesProcedureSignedSignature(taskId: string, employeeId: string) {
  try {
    const response = await apiGet('core', 'documents-signed/policies-procedures', {
      queryParams: {
        task_id: taskId,
        employeeId,
      }
    });
    return response?.content;
  } catch (e) { }
}

export async function postPoliciesProcedureSignedSignature(documentSignatureId: string, employeeId: string) {
  try {
    const response = await apiPost('core','documents-signed/policies-procedures', {
      task_id: documentSignatureId,
      employee_id: employeeId,
    });
    return response;
  } catch (e) { }
}

export async function getPoliciesProcedureSignedAttendance(policies_procedures_id: string) {
  try {
    const response = await apiGet('core','documents-signed/policies-procedures-attendance/' + policies_procedures_id);
    return response?.content;
  } catch (e) { }
}

export async function postPoliciesProcedureSignedAttendance(documentSignatureId: string) {
  try {
    const response = await apiPost('core','documents-signed/policies-procedures-attendance/' + documentSignatureId, {});
    return response;
  } catch (e) { }
}